(function(r) {
    typeof define == "function" && define.amd ? define(["jquery"], r) : typeof module == "object" && module.exports ? module.exports = r(require("jquery")) : r(jQuery)
})(function(r) {
    var g = Array.prototype.slice,
        k = Array.prototype.splice,
        u = {
            topSpacing: 0,
            bottomSpacing: 0,
            className: "is-sticky",
            wrapperClassName: "product-single__form",
            center: !1,
            getWidthFrom: "",
            widthFromWrapper: !0,
            responsiveWidth: !1,
            zIndex: "inherit"
        },
        f = r(window),
        w = r(document),
        p = [],
        v = f.height(),
        d = function() {
            for (var t = f.scrollTop(), n = w.height(), i = n - v, o = t > i ? i - t : 0, c = 0, h = p.length; c < h; c++) {
                var e = p[c],
                    E = e.stickyWrapper.offset().top,
                    W = E - e.topSpacing - o;
                if (e.stickyWrapper.css("height", e.stickyElement.outerHeight()), t <= W) e.currentTop !== null && (e.stickyElement.css({
                    width: "",
                    position: "",
                    top: "",
                    "z-index": ""
                }), e.stickyElement.parent().removeClass(e.className), e.stickyElement.trigger("sticky-end", [e]), e.currentTop = null);
                else {
                    var s = n - e.stickyElement.outerHeight() - e.topSpacing - e.bottomSpacing - t - o;
                    if (s < 0 ? s = s + e.topSpacing : s = e.topSpacing, e.currentTop !== s) {
                        var l;
                        e.getWidthFrom ? (padding = e.stickyElement.innerWidth() - e.stickyElement.width(), l = r(e.getWidthFrom).width() - padding || null) : e.widthFromWrapper && (l = e.stickyWrapper.width()), l == null && (l = e.stickyElement.width()), e.stickyElement.css("width", l).css("position", "fixed").css("top", s).css("z-index", e.zIndex), e.stickyElement.parent().addClass(e.className), e.currentTop === null ? e.stickyElement.trigger("sticky-start", [e]) : e.stickyElement.trigger("sticky-update", [e]), e.currentTop === e.topSpacing && e.currentTop > s || e.currentTop === null && s < e.topSpacing ? e.stickyElement.trigger("sticky-bottom-reached", [e]) : e.currentTop !== null && s === e.topSpacing && e.currentTop < s && e.stickyElement.trigger("sticky-bottom-unreached", [e]), e.currentTop = s
                    }
                    var m = e.stickyWrapper.parent(),
                        x = e.stickyElement.offset().top + e.stickyElement.outerHeight() >= m.offset().top + m.outerHeight() && e.stickyElement.offset().top <= e.topSpacing;
                    x ? e.stickyElement.css("position", "absolute").css("top", "").css("bottom", 0).css("z-index", "") : e.stickyElement.css("position", "fixed").css("top", s).css("bottom", "").css("z-index", e.zIndex)
                }
            }
        },
        y = function() {
            v = f.height();
            for (var t = 0, n = p.length; t < n; t++) {
                var i = p[t],
                    o = null;
                i.getWidthFrom ? i.responsiveWidth && (o = r(i.getWidthFrom).width()) : i.widthFromWrapper && (o = i.stickyWrapper.width()), o != null && i.stickyElement.css("width", o)
            }
        },
        a = {
            init: function(t) {
                return this.each(function() {
                    var n = r.extend({}, u, t),
                        i = r(this),
                        o = i.attr("id"),
                        c = o ? o + "-" + u.wrapperClassName : u.wrapperClassName,
                        h = r("<div></div>").attr("id", c).addClass(n.wrapperClassName);
                    i.wrapAll(function() {
                        if (r(this).parent("#" + c).length == 0) return h
                    });
                    var e = i.parent();
                    n.center && e.css({
                        width: i.outerWidth(),
                        marginLeft: "auto",
                        marginRight: "auto"
                    }), i.css("float") === "right" && i.css({
                        float: "none"
                    }).parent().css({
                        float: "right"
                    }), n.stickyElement = i, n.stickyWrapper = e, n.currentTop = null, p.push(n), a.setWrapperHeight(this), a.setupChangeListeners(this)
                })
            },
            setWrapperHeight: function(t) {
                var n = r(t),
                    i = n.parent();
                i && i.css("height", n.outerHeight())
            },
            setupChangeListeners: function(t) {
                if (window.MutationObserver) {
                    var n = new window.MutationObserver(function(i) {
                        (i[0].addedNodes.length || i[0].removedNodes.length) && a.setWrapperHeight(t)
                    });
                    n.observe(t, {
                        subtree: !0,
                        childList: !0
                    })
                } else window.addEventListener ? (t.addEventListener("DOMNodeInserted", function() {
                    a.setWrapperHeight(t)
                }, !1), t.addEventListener("DOMNodeRemoved", function() {
                    a.setWrapperHeight(t)
                }, !1)) : window.attachEvent && (t.attachEvent("onDOMNodeInserted", function() {
                    a.setWrapperHeight(t)
                }), t.attachEvent("onDOMNodeRemoved", function() {
                    a.setWrapperHeight(t)
                }))
            },
            update: d,
            unstick: function(t) {
                return this.each(function() {
                    for (var n = this, i = r(n), o = -1, c = p.length; c-- > 0;) p[c].stickyElement.get(0) === n && (k.call(p, c, 1), o = c);
                    o !== -1 && (i.unwrap(), i.css({
                        width: "",
                        position: "",
                        top: "",
                        float: "",
                        "z-index": ""
                    }))
                })
            }
        };
    window.addEventListener ? (window.addEventListener("scroll", d, !1), window.addEventListener("resize", y, !1)) : window.attachEvent && (window.attachEvent("onscroll", d), window.attachEvent("onresize", y)), r.fn.sticky = function(t) {
        if (a[t]) return a[t].apply(this, g.call(arguments, 1));
        if (typeof t == "object" || !t) return a.init.apply(this, arguments);
        r.error("Method " + t + " does not exist on jQuery.sticky")
    }, r.fn.unstick = function(t) {
        if (a[t]) return a[t].apply(this, g.call(arguments, 1));
        if (typeof t == "object" || !t) return a.unstick.apply(this, arguments);
        r.error("Method " + t + " does not exist on jQuery.sticky")
    }, r(function() {
        setTimeout(d, 0)
    })
}), $(document).ready(function() {
    $(" button.btn.btn--full.add-to-cart").sticky({
        zIndex: 29
    })
});
//# sourceMappingURL=/s/files/1/0023/1528/8627/t/14/assets/sticky.js.map?v=110576576956935857221606651192